import React from "react";
import PropTypes from "prop-types";

const Icon = ({ pathFill, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5.59571L19.9002 19.2454H4.09974L12 5.59571ZM2.28471 18.1962C1.47686 19.5916 2.48406 21.3437 4.09977 21.3437H19.9002C21.5159 21.3437 22.5231 19.5916 21.7153 18.1962L13.8151 4.54654C13.0072 3.15115 10.9928 3.15115 10.1849 4.54654L2.28471 18.1962ZM10.9508 10.852V13.9995C10.9508 14.5766 11.423 15.0487 12 15.0487C12.577 15.0487 13.0492 14.5766 13.0492 13.9995V10.852C13.0492 10.275 12.577 9.80288 12 9.80288C11.423 9.80288 10.9508 10.275 10.9508 10.852ZM10.9508 17.147C10.9508 16.5676 11.4206 16.0979 12 16.0979C12.5794 16.0979 13.0492 16.5676 13.0492 17.147C13.0492 17.7265 12.5794 18.1962 12 18.1962C11.4206 18.1962 10.9508 17.7265 10.9508 17.147Z"
        fill={pathFill}
      />
    </svg>
  );
};

Icon.propTypes = {
  pathFill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
};

Icon.defaultProps = {
  pathFill: "#FF8B22",
  width: "24",
  height: "24"
};

export default Icon;
